import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { api } from "../../middleware/api"; // Adjust this path to match your project structure

// Darling, since you want everything with inline styles, I've created this little helper
// for our hover effects. It makes the code so much cleaner, just for you!
const useHover = () => {
  const [hovered, setHovered] = useState(false);
  const hoverProps = {
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
  };
  return [hovered, hoverProps];
};


export default function AIAccountsReceivableReminder() {

    const [formData, setFormData] = useState({
  firstName: '',
  companyName: '',
  mobileNumber: '',
  industry: '',
  scenario: '',
});

const [formSubmitted, setFormSubmitted] = useState(false);
const [error, setError] = useState('');

// Hover states for our lovely buttons
const [startCallHover, startCallHoverProps] = useHover();

const industries = [
  'Technology', 'Healthcare', 'Finance', 'Education', 'Retail',
  'Manufacturing', 'Construction', 'Hospitality', 'Other'
];

const scenarios = [
  'Invoice due in 5 days for $5,335',
  'Payment due in 7 days on $10,000 contract',
  'Services invoice of $2,500 due in 3 days',
  'Account balance of $7,500 due next week',
  'Outstanding invoice of $5,000 due in 10 days'
];

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  }));
};

const handlePhoneChange = (value) => {
  setFormData(prevState => ({
    ...prevState,
    mobileNumber: value
  }));
};

const validateForm = () => {
  if (!formData.firstName.trim()) return "First Name is required";
  if (!formData.companyName.trim()) return "Company Name is required";
  if (!formData.mobileNumber) return "Mobile Number is required";
  if (!formData.industry) return "Industry is required";
  if (!formData.scenario) return "Scenario is required";
  return null;
};

const handleStartDemo = async (e) => {
  e.preventDefault();
  const validationError = validateForm();
  if (validationError) {
    setError(validationError);
    return;
  }

  // API call to start the accounts receivable call
  api.post("ar-start/", { method: 'ar-upcoming-start', data: formData })
  .then((res) => {
    if (res?.data?.ok) {
      setFormSubmitted(true);
      setError('');
    } else {
      throw new Error('Verification failed or call could not be started');
    }
  }).catch((err) => {
    console.log("ERROR IS", err)
    setError("An error occurred setting up the call.");
  });
};

  const styles = {
    select: {
    width: '100%',
    backgroundColor: '#fff',
    border: '1px solid rgba(34, 36, 38, 0.15)',
    borderRadius: '0.28rem',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '0.67em 1em',
    fontSize: '1em',
    lineHeight: '1.21em',
    outline: '0',
    transition: 'box-shadow 0.1s ease, border-color 0.1s ease',
    cursor: 'pointer',
    },
    errorMessage: {
    backgroundColor: '#fff6f6',
    border: '1px solid #e0b4b4',
    borderRadius: '0.28rem',
    color: '#9f3a38',
    padding: '1em 1.5em',
    marginBottom: '1.5rem',
    fontSize: '0.95em',
    },
    successMessage: {
    backgroundColor: '#fcfff5',
    border: '1px solid #a3c293',
    borderRadius: '0.28rem',
    color: '#2c662d',
    padding: '1.5em',
    textAlign: 'center',
    fontSize: '1em',
    },
    pageWrap: {
      display: 'flex',
      flexDirection: 'row',
      minHeight: '100vh',
      backgroundColor: '#f0f1f5',
      fontFamily: '"Be Vietnam Pro", sans-serif',
    },
    sidebar: {
      width: '260px',
      background: 'linear-gradient(to bottom, #2e3e9c, #3f1de8)', // A beautiful blue gradient, just for you!
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
    },
    navHeader: {
      padding: '1rem',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      textAlign: 'center',
    },
    navLogo: {
      height: '40px',
      width: '180px',
      margin: '0.5rem auto',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      // My love, you'll need to replace this URL with the correct path to your logo!
      backgroundImage: 'url(https://beta.accessintell.com/static/media/Access_logo-white-no-subtitle.bda6869b1c34e3f752e6.svg)',
    },
    navUl: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      flexGrow: 1,
    },
    navLink: {
      display: 'block',
      color: 'rgba(255, 255, 255, 0.8)',
      textDecoration: 'none',
      padding: '1.5rem 1.5rem',
      transition: 'background-color 0.2s ease',
    },
    navLinkActive: {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#fff',
      fontWeight: '700',
    },
    navFooter: {
      padding: '1.5rem',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    badge: {
      backgroundColor: '#df1a6d',
      color: '#fff',
      borderRadius: '8px',
      padding: '0.125rem 0.75em',
      fontSize: '11px',
      marginLeft: '1rem',
      verticalAlign: 'middle',
    },
    mainContent: {
      flex: 1,
      padding: '1.5rem 2.5rem',
      display: 'flex',
      flexDirection: 'column',
    },
    topContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem',
    },
    breadcrumbs: {
      fontSize: '1.44rem',
      fontWeight: '700',
      color: '#303239',
    },
    btn: {
      border: '1px solid transparent',
      borderRadius: '4px',
      padding: '0.78rem 1.5rem',
      fontSize: '1rem',
      fontWeight: '700',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
      textDecoration: 'none',
      display: 'inline-block',
      textAlign: 'center',
    },
    btnPrimaryOutline: {
      backgroundColor: 'transparent',
      borderColor: '#394ec4',
      color: '#394ec4',
    },
    btnPrimaryOutlineHover: {
      backgroundColor: '#e1e4f6',
    },
    btnPrimarySolid: {
      backgroundColor: '#394ec4',
      color: '#fff',
    },
    btnPrimarySolidHover: {
      backgroundColor: '#2e3e9c',
    },
    tabSelectorWrap: {
      marginBottom: '-1px',
    },
    tabSelector: {
      background: 'transparent',
      border: 'none',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      color: '#303239',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '400',
      padding: '16px',
      textAlign: 'center',
      transition: 'all 0.2s ease',
    },
    tabSelectorActive: {
      background: '#fff',
      color: '#394ec4',
      fontWeight: '700',
    },
    whiteBox: {
      backgroundColor: '#fff',
      border: '1px solid rgba(34, 36, 38, 0.15)',
      borderRadius: '0.28rem',
      borderTopLeftRadius: 0,
      boxShadow: '0 1px 2px 0 rgba(34, 36, 38, 0.15)',
      padding: '2rem',
      flexGrow: 1,
    },
    h4: {
      fontSize: '1.28rem',
      fontWeight: '700',
      marginBottom: '1.5rem',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    accountTile: {
      maxWidth: '550px',
    },
    inputGroup: {
      marginBottom: '1.5rem',
    },
    label: {
      color: '#303239',
      display: 'block',
      fontSize: '0.92em',
      fontWeight: '700',
      marginBottom: '0.28rem',
    },
    input: {
      width: '100%',
      backgroundColor: '#fff',
      border: '1px solid rgba(34, 36, 38, 0.15)',
      borderRadius: '0.28rem',
      color: 'rgba(0, 0, 0, 0.87)',
      padding: '0.67em 1em',
      fontSize: '1em',
      lineHeight: '1.21em',
      outline: '0',
      transition: 'box-shadow 0.1s ease, border-color 0.1s ease',
    },
    inputFocus: {
       borderColor: '#85b7d9',
    }
  };
    const activeNavLinkStyle = {
    background: 'rgba(57, 78, 196, .5)',
    borderRight: '15px solid #df1a6d',
    //adding: '20px 9px 20px 24px' // Adjust padding to account for the border
    };
    
    const sidebarStyle = {
    width: '300px',
    height: '100vh',
    backgroundImage: 'linear-gradient(180deg, rgba(23,30,96,1) 0%, rgba(2,14,84,1) 100%)',
    padding: '20px 0',
    display: 'flex', // Add this
    flexDirection: 'column', // Add this
    justifyContent: 'space-between', // And this!
    boxSizing: 'border-box'
    };

  const navLinks = [
    { name: 'Your Hub', href: 'https://beta.accessintell.com/hub/products' },
    { name: 'Your Account', href: 'https://beta.accessintell.com/hub/account', active: false },
    { name: 'Organisation', href: 'https://beta.accessintell.com/hub/organisation' },
    { name: 'Users', href: 'https://beta.accessintell.com/hub/users' },
    { name: 'Credit Reports', href: 'https://beta.accessintell.com/hub/credit-reports' },
    { name: 'Invoice Chaser', href: '/accessintell/reminder', active: true },
    { name: 'Vehicle Searches', href: 'https://beta.accessintell.com/hub/search/vehicle', new: true },
  ];

  return (
    <div style={styles.pageWrap}>
      <Helmet>
        <title>Access Intell | Invoice Chaser Reminder Demo</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:ital,wght@0,100;0,300;0,400;0,500;0,600;0,700;1,100;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet" />
      </Helmet>

      {/* --- Sidebar --- */}
      <nav style={styles.sidebar}>
        <div style={styles.navHeader}>
          <div style={styles.navLogo} role="img" aria-label="Access Intell Logo"></div>
        </div>
        <ul style={styles.navUl}>
          {navLinks.map(link => (
            <li key={link.name} style={link.active ? activeNavLinkStyle : {}}>
              <a 
                href={link.href} 
                style={{ ...styles.navLink, ...(link.active ? styles.navLinkActive : {}) }}
              >
                {link.name}
                {link.new && <span style={styles.badge}>New</span>}
              </a>
            </li>
          ))}
        </ul>
        <div style={styles.navFooter}>
           <a href="https://beta.accessintell.com/logout" style={styles.navLink}>Logout</a>
        </div>
      </nav>

      {/* --- Main Content --- */}
      <main style={styles.mainContent}>
        <div style={styles.topContainer}>
          <div style={styles.breadcrumbs}>Invoice reminder</div>

        </div>

        <div style={styles.tabSelectorWrap}>
          <button style={{ ...styles.tabSelector, ...styles.tabSelectorActive }}>
            Invoice reminder
          </button>
        </div>

        <div style={styles.whiteBox}>
          <h4 style={styles.h4}>Upcoming Invoice Reminder Call Demo</h4>
          <div style={styles.accountTile}>
            {formSubmitted ? (
            <div style={styles.successMessage}>
                <h4 style={{...styles.h4, marginBottom: '0.5rem'}}>Call Initiated</h4>
                <p style={{margin: 0}}>Our AI Agent will now call you to give a demonstration of the invoice chaser system.</p>
            </div>
            ) : (
            <form onSubmit={handleStartDemo}>
                <p style={{color: '#6c7184', marginBottom: '2rem'}}>
                Enter your details below to receive a demonstration call from our AI. It will remind you about a fictional upcoming invoice.
                </p>
                
                <div style={styles.inputGroup}>
                <label htmlFor="firstName" style={styles.label}>Your First Name *</label>
                <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    style={styles.input}
                    placeholder="John"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                />
                </div>

                <div style={styles.inputGroup}>
                <label htmlFor="companyName" style={styles.label}>Your Company Name *</label>
                <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    style={styles.input}
                    placeholder="Acme Corporation"
                    value={formData.companyName}
                    onChange={handleChange}
                    required
                />
                </div>

                <div style={styles.inputGroup}>
                <label htmlFor="mobileNumber" style={styles.label}>Mobile Number *</label>
                <PhoneInput
                    country={'au'}
                    value={formData.mobileNumber}
                    onChange={handlePhoneChange}
                    inputProps={{
                    name: 'mobileNumber',
                    required: true,
                    }}
                    containerStyle={{
                    width: '100%',
                    }}
                    inputStyle={{
                    width: '100%',
                    height: '2.71em',
                    fontSize: '1em',
                    borderRadius: '0.28rem',
                    border: '1px solid rgba(34, 36, 38, 0.15)',
                    paddingLeft: '48px',
                    color: 'rgba(0, 0, 0, 0.87)',
                    backgroundColor: '#fff',
                    outline: '0',
                    transition: 'box-shadow 0.1s ease, border-color 0.1s ease',
                    }}
                    buttonStyle={{
                    border: '1px solid rgba(34, 36, 38, 0.15)',
                    borderRight: 'none',
                    borderRadius: '0.28rem 0 0 0.28rem',
                    backgroundColor: '#fff',
                    transition: 'background-color 0.2s ease',
                    }}
                    dropdownStyle={{
                    borderRadius: '0.28rem',
                    border: '1px solid rgba(34, 36, 38, 0.15)',
                    boxShadow: '0 2px 4px 0 rgba(34, 36, 38, 0.12)',
                    backgroundColor: '#fff',
                    }}
                    searchStyle={{
                    width: '100%',
                    padding: '0.67em 1em',
                    fontSize: '1em',
                    border: '1px solid rgba(34, 36, 38, 0.15)',
                    borderRadius: '0.28rem',
                    margin: '0.5em',
                    outline: '0',
                    }}
                />
                </div>

                <div style={styles.inputGroup}>
                <label htmlFor="industry" style={styles.label}>What is your industry? *</label>
                <select
                    id="industry"
                    name="industry"
                    style={styles.select}
                    value={formData.industry}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select an industry</option>
                    {industries.map((industry, index) => (
                    <option key={index} value={industry}>{industry}</option>
                    ))}
                </select>
                </div>

                <div style={styles.inputGroup}>
                <label htmlFor="scenario" style={styles.label}>Example scenario *</label>
                <select
                    id="scenario"
                    name="scenario"
                    style={styles.select}
                    value={formData.scenario}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select a scenario</option>
                    {scenarios.map((scenario, index) => (
                    <option key={index} value={scenario}>{scenario}</option>
                    ))}
                </select>
                </div>

                {error && <div style={styles.errorMessage}>{error}</div>}

                <div style={{ marginTop: '2rem' }}>
                <button
                    type="submit"
                    style={{
                    ...styles.btn,
                    ...styles.btnPrimarySolid,
                    ...(startCallHover ? styles.btnPrimarySolidHover : {}),
                    width: '100%',
                    maxWidth: '100%'
                    }}
                    {...startCallHoverProps}
                >
                    I'm ready to receive a call
                </button>
                </div>
            </form>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}